import api from './api';

export default class AvaliacaoEstagioProbatorioService {
  constructor() {
    throw 'Não é possível instanciar AvaliacaoEstagioProbatorioService';
  }

  static async obtem(id) {
    const endpoint = mergeEndpoint(id);
    return await api.get(endpoint);
  }

  static async atualiza(id, item) {
    const endpoint = mergeEndpoint(id);
    return await api.put(endpoint, item);
  }
}

const mergeEndpoint = id => {
  return `avaliacoes-estagio-probatorio/${id}`;
};



// WEBPACK FOOTER //
// ./src/services/avaliacaoEstagioProbatorioService.js